import React from "react";
import { useFormik } from "formik";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLocation } from "react-router";
import BackBtn from "../lib/BackBtn";
import WomenFanCardForm from "./WomenFanCardForm";
import moment from "moment-jalaali";
import { useQuery } from "react-query";
import { getSingleWomanFanCard } from "../../../api/womenFanCard/womenFanCardApi";
import Skeleton from "react-loading-skeleton";
moment.locale("fa");
moment.loadPersian();

function WomenFanCardDetails() {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageFromQuery = searchParams.get("page");
  const idFromQuery = searchParams.get("id");

  const page = pageFromQuery ? parseInt(pageFromQuery) : 1;

  const navigate = useNavigate();
  let location = useLocation();
  const { state } = location as any;

  const {
    data: fanCardData,
    isFetching,
    isError,
    error,
    refetch,
  } = useQuery(
    ["single-woman-fancard"],
    () => getSingleWomanFanCard(idFromQuery || ""),
    {
      enabled: Boolean(idFromQuery),
    }
  );
  const [filePath, setFilePath] = React.useState<any>(null);
  const initialValues = {
    // title: state?.title ? state?.title : null,
    id: fanCardData?.id ? fanCardData?.id : "",
    firstName: fanCardData?.firstName ? fanCardData?.firstName : null,
    lastName: fanCardData?.lastName ? fanCardData?.lastName : null,
    nationalCode: fanCardData?.nationalCode ? fanCardData?.nationalCode : null,
    nationalNumber: fanCardData?.nationalNumber
      ? fanCardData?.nationalNumber
      : null,
    personalImage: fanCardData?.personalImage
      ? fanCardData?.personalImage
      : null,
    nationalCardImage: fanCardData?.nationalCardImage
      ? fanCardData?.nationalCardImage
      : null,
    dateOfBirth: fanCardData?.dateOfBirth
      ? moment(fanCardData?.dateOfBirth).format("jYYYY-jMM-jDD")
      : null,
    education: fanCardData?.education ? fanCardData?.education : null,
    postalCode: fanCardData?.postalCode ? fanCardData?.postalCode : null,
    fullAddress: fanCardData?.fullAddress ? fanCardData?.fullAddress : null,
    status: fanCardData?.status,

    rejectReason: fanCardData?.rejectReason ? fanCardData?.rejectReason : null,
    phoneNumber: fanCardData?.phoneNumber ? fanCardData?.phoneNumber : null,
    mobileNumber: fanCardData?.mobileNumber ? fanCardData?.mobileNumber : null,
    fatherName: fanCardData?.fatherName ? fanCardData?.fatherName : null,
  };
  const [formStatus, setFormStatus] = React.useState<boolean>(state?.active);

  const goBack = () =>
    navigate({
      pathname: `/management-fan/list-women?page=${page}`,
    });
  const formik = useFormik({
    initialValues,
    validationSchema: undefined,
    onSubmit: async (values) => {},
    enableReinitialize: true,
  });

  return (
    <div className={"card"}>
      <div
        className={
          "card-title mt-5 mb-1 px-10 d-flex align-items-center justify-content-between "
        }
      >
        <h2> جزئیات درخواست کاربر</h2>
        <BackBtn onClick={() => goBack()} />
      </div>
      {isFetching ? (
        <div className="m-8">
          <Skeleton
            style={{ width: "300px", height: "30px", marginBlock: "32px" }}
          />
          <Skeleton
            style={{ width: "300px", height: "30px", marginBlock: "32px" }}
          />{" "}
          <Skeleton
            style={{ width: "300px", height: "30px", marginBlock: "32px" }}
          />{" "}
          <Skeleton
            style={{ width: "300px", height: "30px", marginBlock: "32px" }}
          />{" "}
          <Skeleton
            style={{ width: "300px", height: "30px", marginBlock: "32px" }}
          />{" "}
          <Skeleton
            style={{ width: "300px", height: "30px", marginBlock: "32px" }}
          />
        </div>
      ) : (
        <WomenFanCardForm
          formik={formik}
          labels={{ sendBtnLabel: "ذخیره" }}
          formType={initialValues.id ? "edit" : "create"}
          setFormStatus={setFormStatus}
          banner={state?.gameBanner ? state?.gameBanner : null}
          filePath={filePath}
        />
      )}
    </div>
  );
}

export default WomenFanCardDetails;
